import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { Link, withRouter } from 'react-router-dom';
import { ObjectAnimal } from '../parts/logo.jsx';
import classNames from 'classnames';
import { connect } from 'react-redux';
import isTouch from 'is-touch';
import Div100vh from 'react-div-100vh';

class Artists extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      artistsActive: false,
      artist: false
    }
  }
  componentDidMount(){
    document.body.style.background = '';
    document.body.classList.remove('dark');
  }
  _handleMouseEnter(e, type, artist){
    this.setState({
      artistsActive:type,
      artist
    });
  }
  _handleMouseLeave(){
    this.setState({
      artistsActive:false,
      artist: false
    });
  }
  render () {
    const { location, directors, photographers } = this.props;

    return <Div100vh className={classNames('page page--artists transition', this.state.artistsActive && `hovered hovered--${this.state.artistsActive}`)}>
      <div className="inner inner--flex">
        <div className="artists artists--directors">
          <h4>Directors</h4>
          <ul>
            {directors && directors.map(artist => {
              if(artist.status !== 'publish'){
                return false;
              }
              return <li key={artist.slug}>
                <Link
                  to={`/directors/${artist.slug}`}
                  onMouseEnter={(e) => this._handleMouseEnter(e, 'directors', artist)}
                  onMouseLeave={() => this._handleMouseLeave()}
                  style={{color: (artist == this.state.artist) && this.state.artist.acf.primary_color }}
                  >
                  <span dangerouslySetInnerHTML={{__html: artist.title.rendered}} />

                  {artist.acf.superscript &&
                    <span className="superscript">{artist.acf.superscript}</span>
                  }
                </Link>
              </li>
            })}
          </ul>
        </div>
        <div className="artists artists--photographers">
          <h4>Photographers</h4>
          <ul>
            {photographers && photographers.map(artist => {
              return <li key={artist.slug}>
                <Link
                  to={`/photographers/${artist.slug}`}
                  onMouseEnter={(e) => this._handleMouseEnter(e, 'photographers', artist)}
                  onMouseLeave={() => this._handleMouseLeave()}
                  style={{color: (artist == this.state.artist) && this.state.artist.acf.primary_color }}
                  >
                  <span dangerouslySetInnerHTML={{__html: artist.title.rendered}} />

                  {artist.acf.superscript &&
                    <span className="superscript">{artist.acf.superscript}</span>
                  }
                </Link>
              </li>
            })}
          </ul>
        </div>
      </div>

      {!isTouch &&
        <React.Fragment>
          <div className="director__preview">
          {directors && directors.map(director => {
            if(director.acf.videos){
              const { preview_video, video } = director.acf.videos[0];
              const previewVideo = preview_video ? preview_video : video;

              return (
                <div key={director.id} className={classNames('preview', {'preview--visible': this.state.artist == director})}>
                {director.acf.videos &&
                  <video autoPlay playsInline muted loop preload="auto">
                  <source src={previewVideo.url} type={previewVideo.mime_type} />
                  </video>
                }
                </div>
              );
            }
          })}
          </div>
          <div className="photographer__preview">
            {photographers && photographers.map(artist => {
              const format = artist.better_featured_image && (artist.better_featured_image.media_details.width > artist.better_featured_image.media_details.height) ? 'landscape' : 'portrait';
              return <div key={artist.id} className={classNames('preview', `preview--${format}`, {
                'preview--visible': this.state.artist == artist
              })}>
              <div className="preview__inner" style={{
                backgroundImage: artist.better_featured_image && `url(${artist.better_featured_image.media_details.sizes.fullscreen ? artist.better_featured_image.media_details.sizes.fullscreen.source_url : artist.better_featured_image.source_url})`
              }} />
              </div>
            })}
          </div>
        </React.Fragment>
      }
    </Div100vh>;
  }
}



const mapStateToProps = (state, ownProps) => {
  return {
    directors: state.directors.directors.filter(director => !director.acf.hide_artist),
    photographers: state.photographers.photographers,
  }
}

export default connect(mapStateToProps, null)(Artists);
